<template lang="pug">
  money(v-model="model" v-bind="$attrs")
</template>

<script>
export default {
  props: { value: { type: [String, Number] } },
  computed: {
    model: {
      get() {
        return this.value / 100
      },
      set(v) {
        this.$emit('input', v * 100)
      },
    },
  },
}
</script>
